<template>
    <div>
        <v-navigation-drawer
                v-model="drawer"
                fixed
                v-if="$vuetify.breakpoint.smAndDown"
        >
            <v-list dense>

                <v-list-tile  @click="scrollToEl('home')">
                    <v-list-tile-content>
                        <v-list-tile-title >
                            Home
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile @click="scrollToEl('prodotto')">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Il prodotto
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile @click="scrollToEl('rata')">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            La tua rata
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile @click="scrollToEl('opinions')">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Dicono di noi
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

            </v-list>

        </v-navigation-drawer>
        <v-toolbar app dark fixed :color="config.campagnaWeb=='S' ? 'primary' : 'primary'">
            <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
            <v-layout justify-center row class="hidden-sm-and-down">
                <v-toolbar-items>
                    <v-btn flat @click="scrollToEl('home')">Home</v-btn>
                    <v-btn v-if="this.showHome" flat @click="scrollToEl('prodotto')">Il prodotto</v-btn>
                    <v-btn v-if="this.showHome" flat @click="scrollToEl('rata')" >La tua rata</v-btn>
                    <v-btn v-if="this.showHome" flat @click="scrollToEl('opinions')" >Dicono di noi</v-btn>
                </v-toolbar-items>
            </v-layout>
        </v-toolbar>
    </div>

</template>

<script>
    export default {
        data (){
            return {
                drawer:false
            }
        },
        props:{
            config: {
            },
            showHome: {
            }
        },
        methods:{
            scrollToEl(name){
                if(!this.showHome) {
                    this.$emit('changeShowHome');
                } else {
                    this.$emit('scrollTo', name);
                    this.drawer = false;
                }
            }
        }
    }
</script>